import React from 'react';
import ReactComment from 'Utils/ReactComment';
import { Link } from 'react-router-dom';

import './footer.less';

const Footer: React.StatelessComponent<{}> = (props) => {
  return (
    <footer>
      <div id="fndry-footer-holder" className="nopad" style={{ position: 'relative', width: '100%', height: '186px', backgroundColor: 'black' }}>

        <div id="fndry-footer-logo-holder" style={{ position: 'absolute', left: '65px', top: '48px', width: 'auto', height: 'auto' }}>
          <a href="https://www.shawcontract.com/en-US/Segments/Hospitality" target="_blank">
            <div id="fndry-footer-logo" style={{ display: 'inline-block', width: '140px', height: '50px', backgroundSize: 'contain', backgroundRepeat: 'no-repeat' }}></div>
          </a>
        </div>

        <div id="fndry-footer-links-container" className="nopad showmec" style={{ position: 'absolute', left: '65px', top: '110px', width: 'auto', height: 'auto', textAlign: 'center', zIndex: 10000 }}>
          <a href="/help" id="fndry-footer-links-need-assistance" className="fndry-footer-menu-bar-links">Need Assistance?</a>
          <a href="/help" className="fndry-footer-menu-bar-links">Privacy & Terms of Use</a>
          <Link to="https://shawinc.com/Legal-Disclosures" target="_blank" className="fndry-footer-menu-bar-links">Legal Disclosures</Link>
          <Link to="https://shawinc.com/Modern-Slavery-Statement" target="_blank" className="fndry-footer-menu-bar-links">Modern Slavery Statement</Link>
          <ReactComment text="OneTrust Cookies Settings button start" />
          <a id="ot-sdk-btn" className="ot-sdk-show-settings fndry-footer-menu-bar-links">Do Not Sell or Share My Personal Information</a>
          <ReactComment text="OneTrust Cookies Settings button end" />
        </div>
        <div id="fndry-footer-copy-container" className="nopad nosel showmec" style={{ position: 'absolute', left: '63px', top: '136px', width: 'auto', color: '#757575', fontSize: '14px' }}>
          <span id="fndry-footer-copy"> &copy; {new Date().getFullYear()} Shaw Industries Group, Inc., a Berkshire Hathaway Company </span>
        </div>

        <div id="fndry-footer-social-container" className="nopad showmec" style={{ position: 'absolute', left: '0px', top: '105px', width: '100%', textAlign: 'right' }}>
          <ul id="fndry-footer-social-ul" className="list-unstyled" style={{ paddingRight: '65px' }}>
            <li className="fndry-ul-li-horizontal">
              <a href="https://www.facebook.com/ShawContract" className="fndry-footer-social" target="_blank">
                <i className="fab fa-facebook-f"></i>
              </a>
            </li>
            <li className="fndry-ul-li-horizontal">
              <a href="https://www.instagram.com/ShawContract/" className="fndry-footer-social" target="_blank">
                <i className="fab fa-instagram"></i>
              </a>
            </li>
            <li className="fndry-ul-li-horizontal">
              <a href="https://www.linkedin.com/company/ShawContract" className="fndry-footer-social" target="_blank">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </li>
            <li className="fndry-ul-li-horizontal">
              <a href="https://www.pinterest.com/ShawContract/" className="fndry-footer-social"
                target="_blank">
                <i className="fab fa-pinterest-p"></i>
              </a>
            </li>
            <li className="fndry-ul-li-horizontal">
              <a href="https://twitter.com/ShawContract" className="fndry-footer-social" target="_blank">
                <i className="fab fa-twitter"></i>
              </a>
            </li>
            <li className="fndry-ul-li-horizontal">
              <a href="https://www.youtube.com/user/ShawContractGroup1" className="fndry-footer-social" target="_blank">
                <i className="fab fa-youtube"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
